/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconContrast = createReactComponent("outline", "contrast", "IconContrast", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 17a5 5 0 0 0 0 -10v10", "key": "svg-1" }]]);

export { IconContrast as default };
//# sourceMappingURL=IconContrast.mjs.map
